import { useEffect, useRef, useState } from "react";
import { LANGUAGE } from "services/general";

const MAX_TEXTAREA_HEIGHT_COMPACT = 120;
const MAX_TEXTAREA_HEIGHT_EXPANDED = 160;

export function useChatComposer({ variant, inputValue, selectedFile }) {
  const isCompact = variant === "compact";
  const isRtl = LANGUAGE === "ar";
  const textareaRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const maxTextareaHeight = isCompact
    ? MAX_TEXTAREA_HEIGHT_COMPACT
    : MAX_TEXTAREA_HEIGHT_EXPANDED;
  const attachButtonSize = isCompact ? "w-8 h-8" : "w-9 h-9";
  const sendButtonSize = isCompact ? "w-8 h-8" : "w-[38px] h-[38px]";

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxTextareaHeight)}px`;
  }, [inputValue, maxTextareaHeight]);

  // Generate/revoke an image preview when the selected file is a picture.
  useEffect(() => {
    if (
      selectedFile &&
      selectedFile.type &&
      selectedFile.type.startsWith("image/")
    ) {
      const url = URL.createObjectURL(selectedFile);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setPreviewUrl(null);
  }, [selectedFile]);

  return {
    isCompact,
    isRtl,
    textareaRef,
    previewUrl,
    maxTextareaHeight,
    attachButtonSize,
    sendButtonSize,
  };
}
